import { ActivatedRouteSnapshot, ResolveFn, Route, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { LaborProtokollService } from './labor-protokoll.service';
import {
  ILaborProtokollParams,
  MgsRole,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_KIDS,
  ROLE_MGS_REZEPTION,
  ROLE_MGS_SPOWI,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { codetableResolver } from '../../codetable/codetable.resolver';
import { mgsExclusionRoleGuard } from '../../mgs-guards';
import { LABOR_PROTOKOLL_PATH, LABOR_PROTOKOLL_TITLE } from '../../mgs-path-defs';
import { PartnerAuswahlService } from '../../partner/partner-auswahl/partner-auswahl.service';
import { AuthStateFacade } from '../../auth/auth-state.facade';
import { partnerResolver } from '../../partner/partner.resolver';

const laborProtokollResolver: ResolveFn<number | undefined> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authState = inject(AuthStateFacade);
  const laborService = inject(LaborProtokollService);
  const partnerAuswahlService = inject(PartnerAuswahlService);
  const params: ILaborProtokollParams = laborService.laborProtokollParams();

  let ermitteln = true;
  if (authState.isAdmin()) {
    params.partnerId = partnerAuswahlService.partnerIdErmitteln(route);
    ermitteln = !!params.partnerId;
  }

  if (ermitteln) {
    const queryParams = { ...params, ...route.queryParams };
    await laborService.laborProtokolleErmittelnWennNotwendig(queryParams);
  }

  return params?.partnerId;
};

export const laborRolesForExclusion: MgsRole[] = [
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_SPOWI,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_REZEPTION
];

export const laborProtokollRoute: Route = {
  path: LABOR_PROTOKOLL_PATH,
  title: LABOR_PROTOKOLL_TITLE,
  loadComponent: () => import('./labor-protokoll.component').then((c) => c.LaborProtokollComponent),
  resolve: {
    labor: laborProtokollResolver,
    icons: mgsIconsResolver,
    partner: partnerResolver,
    codetable: codetableResolver
  },
  canActivate: [mgsExclusionRoleGuard(laborRolesForExclusion)]
};
